import React from 'react'
import styled from 'styled-components'
import QuantityInput from 'pageComponents/_common/form/quantityInput'
import { Detail1 as SkeletonDetail } from 'pageComponents/SearchResults/uiComponents/skeletonItem'
import ItemImage from '../../_common/ItemImage'

const DivPartImg = styled.div`
  display: flex;
  width: 100px;
  height: 100px;
  background-color: white;
`

const PartTitle = styled.div`
  margin: 0;
  font-weight: 700;
`

const ButtonRed = styled.button`
  background-color: #b51029;
  color: white;
  font-weight: 600;
  border: 0;
  padding: 4px 8px;
  box-shadow: 1px 1px 2px #000;
  margin: 4px auto;
  &:hover{
    background-color: rgb(219, 22, 51);
  }
  &:active{
    background-color: #b51029;
    box-shadow: 0px 0px 1px #000;
  }
`

const ACall = styled.a`
  color: #328EFC;
  font-weight: 700;
  padding: 0 4px;
`

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`

const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
`

const FixedWidth = styled.div`
  width: 300px
`

const Key = styled.span`
font-weight: 500;
margin: 0 4px;
`

const Value = styled.span`
  font-size: 12px;
`

export default function BomItem(props) {
    const {
        itemCode,
        invMastUid,
        extendedDesc,
        unitPrice,
        availability,
        unitOfMeasure,
        quantity,
        details,
        itemCodeUrlSanitized,
        setShowAddedToCartModal,
        setQuantity,
        unitSize,
        roundType,
        hasPrice,
        addItem
    } = props

    function handleAddToCart() {
        if (quantity > 0) {
            addItem({
                invMastUid,
                quantity,
                itemUnitPriceOverride: null,
                customerPartNumberId: null
            })
            setShowAddedToCartModal(true)
        }
    }

    const itemLink = `/product/${itemCodeUrlSanitized}/${invMastUid}`

    return (
        <FlexRow>
            <div>
                <DivPartImg>
                    <a href={itemLink}>
                        <ItemImage size='thumbnail' details={details} lazy={true} />
                    </a>
                </DivPartImg>
            </div>
            <FixedWidth>
                <FlexCol>
                    <div>
                        <PartTitle><a href={itemLink}>{itemCode}</a></PartTitle>
                    </div>

                    <div>
                        <Value>AHC{invMastUid}</Value>
                    </div>

                    <div>
                        <Value>{extendedDesc}</Value>
                    </div>
                </FlexCol>
            </FixedWidth>
            <FlexCol>
                {unitPrice ? (
                    <FlexRow>
                        <Key>Unit Price: </Key>
                        <Value>${unitPrice.toFixed(2)}</Value>

                    </FlexRow>
                ) : !hasPrice ? (
                    <FlexRow>
                        <SkeletonDetail style={{ margin: 'auto 0 auto 75px', width: 50 }} />
                    </FlexRow>
                ) : (
                    <ACall href="tel:+18009997378">Call for Price</ACall>
                )}
                <div>
                    <Key>Availability: </Key>
                    <Value>{availability} / {unitOfMeasure}</Value>
                </div>
            </FlexCol>
            <div>
                <QuantityInput
                    quantity={quantity}
                    unitSize={unitSize}
                    unitOfMeasure={unitOfMeasure}
                    roundType={roundType}
                    handleUpdate={setQuantity}
                    min='0'
                    debounce
                />
                <div>
                    {!!hasPrice && <ButtonRed onClick={handleAddToCart}>Add to Cart</ButtonRed>}
                </div>
            </div>
        </FlexRow>
    )
}
